import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from './common/Footer';
import ScrollToTop from './ScrollToTop';
import ScrollingBanner from './ScrollingBanner';
import metaPixelService from '../services/metaPixelService';
import styles from '../styles/SpecialOffer.module.css';
import astrologer from '../assets/astrologer.jpg';
// import gamStar from '../assets/gam_star.png';

// SVG Icon Components
const Icons = {
  Chart: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="20" x2="12" y2="10" />
      <line x1="18" y1="20" x2="18" y2="4" />
      <line x1="6" y1="20" x2="6" y2="16" />
    </svg>
  ),

  Graduation: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M22 10L12 5L2 10L12 15L22 10Z" />
      <path d="M6 12v5c0 2 3 3 6 3s6-1 6-3v-5" />
    </svg>
  ),

  Lock: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  ),

  Message: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
    </svg>
  ),

  Lightning: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
    </svg>
  ),

  Briefcase: () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
    </svg>
  ),

  Heart: () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
    </svg>
  ),

  Money: () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="6" y1="7" x2="18" y2="7" strokeLinecap="round" />
      <line x1="6" y1="10" x2="18" y2="10" strokeLinecap="round" />
      <path d="M8 10 L8 18 Q8 20 10 20 L14 20" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="8" y1="7" x2="8" y2="4" strokeLinecap="round" />
    </svg>
  ),

  Book: () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
    </svg>
  ),

  Home: () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
      <polyline points="9 22 9 12 15 12 15 22" />
    </svg>
  ),

  Building: () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="4" y="2" width="16" height="20" rx="1" strokeLinecap="round" strokeLinejoin="round" />
      <line x1="8" y1="6" x2="8" y2="6" strokeLinecap="round" />
      <line x1="12" y1="6" x2="12" y2="6" strokeLinecap="round" />
      <line x1="16" y1="6" x2="16" y2="6" strokeLinecap="round" />
      <line x1="8" y1="10" x2="8" y2="10" strokeLinecap="round" />
      <line x1="12" y1="10" x2="12" y2="10" strokeLinecap="round" />
      <line x1="16" y1="10" x2="16" y2="10" strokeLinecap="round" />
      <line x1="8" y1="14" x2="8" y2="14" strokeLinecap="round" />
      <line x1="12" y1="14" x2="12" y2="14" strokeLinecap="round" />
      <line x1="16" y1="14" x2="16" y2="14" strokeLinecap="round" />
      <rect x="10" y="18" width="4" height="4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),

  XCircle: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  ),

  CheckCircle: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
      <polyline points="22 4 12 14.01 9 11.01" />
    </svg>
  ),

  ArrowDown: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <line x1="12" y1="5" x2="12" y2="19" />
      <polyline points="19 12 12 19 5 12" />
    </svg>
  ),

  Shield: () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  ),

  Lightbulb: () => (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M9 18h6" />
      <path d="M10 22h4" />
      <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0018 8.5 5.5 5.5 0 007 8.5c0 1.33.47 2.5 1.41 3.5.76.76 1.23 1.52 1.41 2.5" />
    </svg>
  )
};

const TESTIMONIALS = [
  {
    quote:
      "सरांच्या सखोल ज्योतिषज्ञानामुळे आमच्या कुटुंबाला नेहमीच अचूक आणि उपयुक्त मार्ग मिळाला. खूप आभारी आहोत.",
    name: "सौ. मंजिरी जोशी",
    role: "Renowned Research Scientist"
  },
  {
    quote:
      "Mr. Kelkar has been our family's trusted mentor for decades - accurate, insightful, and deeply practical.",
    name: "Govardhan Bihani",
    role: "Ahilyanagar"
  },
  {
    quote:
      "Consulting Suneel Kelkar Sir changed my life. His predictions and remedies brought clarity and positive change.",
    name: "Aditya Oke",
    role: "Renowned Graphologist & Vaastu Consultant"
  },
  {
    quote:
      "Accurate guidance on career, health, home and finances - always timely and practical.",
    name: "Mayur Datar",
    role: "Chartered Accountant"
  },
  {
    quote:
      "Clear, consistent, actionable market guidance - one of the biggest reasons I've stayed active in markets.",
    name: "Mr. Atul Vyas",
    role: "Senior Portfolio Management Consultant"
  },
  {
    quote:
      "Since 2006, Shri Suneel Kelkar's accurate predictions, practical remedies, and mentorship have profoundly shaped my life and career.",
    name: "Mr. Aashish Kulkarni",
    role: "Senior VP, Cyber Security Leader"
  }
];

const FAQS = [
  {
    question: "Session साठी नेमकं काय द्यावं लागेल?",
    answer: "तुमची जन्म तारीख, जन्म वेळ (शक्य तितकी अचूक) आणि जन्म ठिकाण. वेळ नक्की माहीत नसेल तर तसं सांगा — Dr. Kelkar उपलब्ध माहितीनुसार पत्रिका मांडतील."
  },
  {
    question: "जन्म वेळ नक्की माहीत नाही, तरी book करू शकतो का?",
    answer: "हो. जेवढी माहिती आहे तेवढी द्या. काही ठराविक predictions वेळेशिवाय थोडी कमी अचूक होतात — कोणती ते Dr. Kelkar स्पष्ट सांगतील."
  },
  {
    question: "Session कसं होणार?",
    answer: "Online — video किंवा voice call, तुमच्या सोयीनुसार. Link आणि वेळ WhatsApp वर confirm केली जाते."
  },
  {
    question: "Consultation कोणत्या भाषेत असेल?",
    answer: "मराठी, हिंदी किंवा English — booking करताना तुमची पसंती सांगा."
  },
  {
    question: "Slot किती लवकर मिळेल?",
    answer: "Payment नंतर 24 तासांच्या आत तुमचा slot WhatsApp वर confirm केला जातो — त्या आठवड्याच्या availability नुसार."
  },
  {
    question: "मला प्रत्यक्ष Dr. Kelkar यांच्याशीच बोलायला मिळेल का?",
    answer: "हो. प्रत्येक session स्वतः Dr. Kelkar घेतात — कधीही कोणाकडे delegate केलं जात नाही."
  },
  {
    question: "Reports वेळेत नाही मिळाले तर?",
    answer: "तुम्हाला पूर्ण refund मिळेल, कोणतेही प्रश्न न विचारता. हे आमच्या T&C चा भाग आहे."
  },
  {
    question: "महाग पूजा किंवा रत्न घ्यायला सांगतील का?",
    answer: "नाही. पत्रिकेत उपाय सुचत असतील तरच ते सुचवले जातात, आणि त्यामागचं कारणही समजावून सांगितलं जातं. Session मध्ये कोणताही upselling नाही."
  },
  {
    question: "कुटुंबातील एखाद्याच्या पत्रिकेबद्दल विचारू शकतो का?",
    answer: "Session तुमच्या पत्रिकेबद्दल असतं. कुटुंबाशी संबंधित प्रश्न तुमच्या निर्णयाशी जोडलेला असेल तर विचारा — तुमची पत्रिका काय सांगते ते कळेल. वेगळ्या पत्रिकेसाठी वेगळं session लागेल."
  },
  {
    question: "Session ची copy मिळेल का?",
    answer: "हो. तुम्हाला पूर्ण recording आणि लिखित Remedy Action Report दोन्ही मिळतं."
  }
];

// Custom hook for counting up animation
const useCountUp = (end, duration = 1500, isVisible = false) => {
  const [count, setCount] = useState(0);
  const hasAnimatedRef = useRef(false);

  useEffect(() => {
    if (!isVisible || hasAnimatedRef.current) return;

    hasAnimatedRef.current = true;
    const startTime = Date.now();
    const endValue = typeof end === 'number' ? end : parseInt(end.toString().replace(/[^0-9]/g, ''));

    const timer = setInterval(() => {
      const now = Date.now();
      const progress = Math.min((now - startTime) / duration, 1);

      // Easing function for smooth animation
      const easeOutQuart = 1 - Math.pow(1 - progress, 4);
      const currentCount = Math.floor(easeOutQuart * endValue);

      setCount(currentCount);

      if (progress >= 0.99) {
        clearInterval(timer);
        setCount(endValue);
      }
    }, 16); // ~60fps

    return () => clearInterval(timer);
  }, [end, duration, isVisible]);

  return count;
};

export default function SpecialOffer({ onNavigateToSignIn }) {
  const navigate = useNavigate();
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [visibleSections, setVisibleSections] = useState(new Set());
  const [showAllTestimonials, setShowAllTestimonials] = useState(false);
  const socialProofRef = useRef(null);

  // Number animations
  const heroKundliCount = useCountUp(150000, 1200, visibleSections.has('hero'));
  const trustClientCount = useCountUp(5000, 1200, visibleSections.has('trust'));
  const trustQuestionCount = useCountUp(150000, 1200, visibleSections.has('trust'));
  const trustYearsCount = useCountUp(35, 1200, visibleSections.has('trust'));
  const finalProofCount = useCountUp(150000, 1200, visibleSections.has('finalcta'));

  const handleCTAClick = () => {
    navigate('/consultation', { state: { showForm: true } });
  };

  // Scroll-triggered animations using Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections(prev => new Set([...prev, entry.target.dataset.section]));
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('[data-section]').forEach((section) => {
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  // Separate observer for Trust section number animations
  useEffect(() => {
    if (!socialProofRef.current) return;

    const numberObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisibleSections(prev => new Set([...prev, 'trust']));
            // Unobserve after triggering to prevent re-animation
            numberObserver.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.5,  // 50% of the banner visible
        rootMargin: '0px'
      }
    );

    numberObserver.observe(socialProofRef.current);

    return () => numberObserver.disconnect();
  }, []);

  useEffect(() => {
    setShowStickyCTA(visibleSections.has('mentor'));
  }, [visibleSections]);

  // Track PageView when component mounts
  useEffect(() => {
    metaPixelService.trackPageView();
  }, []);


  return (
    <>
      <ScrollToTop />

      {/* Banner #2: Daily Urgency (Sticky) */}
      <ScrollingBanner
        content={[
          'दर आठवड्याला मर्यादित slots',
          '35+ वर्षांचा अनुभव · 1,50,000+ पत्रिका अभ्यासलेल्या',
          '1-on-1 session — group call नाही',
          'रिपोर्ट वेळेत न मिळाल्यास 100% refund'
        ]}
        speed={18}
        backgroundColor="#B21F25"
        textColor="#FFFFFF"
        fontWeight="bold"
        isSticky={true}
        zIndex={1000}
      />

      <div className={styles.specialOfferPage}>

        {/* Hero Section */}
        <section className={styles.heroSection} data-section="hero">
          <svg className={styles.kundliMotif} viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <rect x="20" y="20" width="360" height="360" stroke="currentColor" strokeWidth="1" />
            <path d="M20 20L380 380M380 20L20 380" stroke="currentColor" strokeWidth="1" />
            <path d="M200 20L380 200L200 380L20 200Z" stroke="currentColor" strokeWidth="1" />
          </svg>

          <div className={styles.heroContent}>
            <h1 className={styles.heroHeadline}>
              तुमच्या पत्रिकेत उत्तर आधीच लिहिलेलं आहे.<br />
              फक्त ते अजून नीट वाचलं गेलेलं नाही.
            </h1>

            <p className={styles.heroSubheadline}>
              Dr. Suneel Kelkar यांच्यासोबत 1 तासाचं personal consultation — सोबत सविस्तर Kundali report, तुमच्या session ची recording, आणि प्रत्यक्ष अमलात आणता येईल असा remedy plan.
            </p>

            <div className={styles.priceHighlight}>
              <span className={styles.oldPrice}>₹6,000</span>
              <span className={styles.newPrice}>₹2,550</span>
            </div>

            <button className={styles.primaryCTA} onClick={handleCTAClick}>
              माझं Session Book करा — ₹2,550
            </button>

            <div className={styles.trustLine}>
              <span>35+ वर्षांचा अनुभव</span>
              <span className={styles.separator}>|</span>
              <span>{heroKundliCount.toLocaleString()}+ पत्रिका अभ्यासलेल्या</span>
              <span className={styles.separator}>|</span>
              <span>1-on-1, group call नाही</span>
            </div>

            <p className={styles.microCopy}>
              दर आठवड्याला मर्यादित slots · रिपोर्ट वेळेत न मिळाल्यास 100% refund
            </p>
          </div>
        </section>

        {/* Banner #1: Pune Area Social Proof */}
        <ScrollingBanner
          content={[
            'Kothrud मधील कुटुंबाने career बद्दल Clarity Session घेतलं',
            'Baner मधील client ला लग्नाच्या timing बद्दल स्पष्टता मिळाली',
            'Deccan मधील कुटुंबाने property निर्णयासाठी session घेतलं',
            'Hinjewadi मधील client ला ranked remedies मिळाल्या',
            '35+ वर्षांत Pune व महाराष्ट्रातील हजारो कुटुंबांनी विश्वास ठेवला'
          ]}
          speed={25}
          backgroundColor="#B21F25"
          textColor="#FFFFFF"
        />

        {/* Problem Section */}
        <section className={styles.problemSection} data-section="problem">
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionHeadline}>
              बहुतेकांना अजून predictions नकोत. पुढे काय करायचं याची स्पष्टता हवी असते.
            </h2>

            <p className={styles.agitationText}>
              तुम्ही आधीच कोणाला ना कोणाला तुमची पत्रिका दाखवली असेल. कदाचित एकापेक्षा जास्त वेळा. आणि हातात आलं काय — "शनी जड आहे", "सहा महिने थांबा", "हे पाठ करा." कदाचित बरोबरही असेल. पण उपयोगी नाही. सोमवारी सकाळी नक्की काय करायचं, हे कधीच कळत नाही.
            </p>

            <ul className={styles.painPoints}>
              <li className={styles.painPoint}>
                <span className={styles.icon}><Icons.Briefcase /></span>
                <p>कोणालाही लागू पडेल इतकं generic reading</p>
              </li>
              <li className={styles.painPoint}>
                <span className={styles.icon}><Icons.Book /></span>
                <p>लिखित काहीच नाही — संध्याकाळपर्यंत अर्धं विसरून जाता</p>
              </li>
              <li className={styles.painPoint}>
                <span className={styles.icon}><Icons.Home /></span>
                <p>Priority किंवा timeline न सांगता दिलेले उपाय</p>
              </li>
              <li className={styles.painPoint}>
                <span className={styles.icon}><Icons.Heart /></span>
                <p>तुमच्या प्रश्नाला एक तास हवा असताना मिळालेली घाईतली 10 मिनिटं</p>
              </li>
              <li className={styles.painPoint}>
                <span className={styles.icon}><Icons.Building /></span>
                <p>प्रसंग प्रत्यक्ष आल्यावर मार्गदर्शन परत बघायला काही साधनच नाही</p>
              </li>
            </ul>

            <p className={styles.transitionLine}>
              नेमकं हेच सोडवण्यासाठी हे session बनवलं आहे.
            </p>
          </div>
        </section>

        {/* Solution Section */}
        <section className={styles.solutionSection} data-section="solution">
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionHeadline}>
              एक तास. तुमची पत्रिका. तुमचे खरे प्रश्न. लिखित स्वरूपात.
            </h2>

            <p className={styles.agitationText}>
              Dr. Kelkar Clarity Session हा पूर्ण consultation आहे — घाईतलं reading नाही. तुम्ही भेटण्याआधीच Dr. Kelkar तुमची पत्रिका अभ्यासतात, त्यामुळे संपूर्ण तास तुमच्या situation वर खर्च होतो, data entry वर नाही.
            </p>

            <div className={styles.valuePropsGrid}>
              <article className={styles.valuePropCard}>
                <div className={styles.cardIcon}><Icons.Chart /></div>
                <h3 className={styles.cardTitle}>पत्रिकेचं संपूर्ण वाचन</h3>
                <p className={styles.cardDescription}>Dasha, transits आणि पुढच्या महत्त्वाच्या periods</p>
              </article>

              <article className={styles.valuePropCard}>
                <div className={styles.cardIcon}><Icons.Briefcase /></div>
                <h3 className={styles.cardTitle}>तुमचे specific प्रश्न</h3>
                <p className={styles.cardDescription}>Career, marriage, finances, property, family, timing</p>
              </article>

              <article className={styles.valuePropCard}>
                <div className={styles.cardIcon}><Icons.Shield /></div>
                <h3 className={styles.cardTitle}>स्पष्ट उत्तर</h3>
                <p className={styles.cardDescription}>सध्याचा period काय support करतो, काय नाही — स्पष्टपणे</p>
              </article>

              <article className={styles.valuePropCard}>
                <div className={styles.cardIcon}><Icons.Lightbulb /></div>
                <h3 className={styles.cardTitle}>Priority ठरवलेले उपाय</h3>
                <p className={styles.cardDescription}>तुमच्या पत्रिकेनुसार, priority आणि कालावधीसह</p>
              </article>
            </div>

            <p className={styles.transitionLine}>
              तुमच्याकडे शेवटी recording, लिखित report आणि नेमकं काय करायचं याची स्पष्ट यादी असेल.
            </p>

            <button className={styles.primaryCTA} onClick={handleCTAClick}>
              माझं Session Book करा — ₹2,550
            </button>
          </div>
        </section>

        {/* Meet Your Mentor Section */}
        <section className={styles.mentorSection} data-section="mentor">
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionHeadline}>35 वर्षं. 1.5 लाख पत्रिका. एका वेळी एक consultation.</h2>

            <div className={styles.mentorGrid}>
              <div className={styles.mentorAside}>
                <div className={styles.mentorPhotoWrapper}>
                  <div className={styles.mentorPhoto}>
                    <img src={astrologer} alt="Dr. Suneel Kelkar" className={styles.photoCircular} />
                  </div>
                </div>
                <h3 className={styles.mentorName}>Dr. Suneel Kelkar</h3>
                <p className={styles.mentorCredentials}>
                  35+ वर्षांचा full-time Vedic astrology practice
                </p>
              </div>

              <div className={styles.mentorBio}>
                <p className={styles.mentorExperience}>
                  1,50,000+ पत्रिका अभ्यासलेल्या — कुटुंब, business, health निर्णय आणि life transitions मध्ये.
                </p>
                <p className={styles.agitationText}>
                  त्यांची पद्धत consultative आहे, नाट्यमय नाही. भीती दाखवणारे इशारे नाहीत, पूजा घेण्यासाठी आग्रह नाही, अस्पष्ट आश्वासनं नाहीत. पत्रिका काय सांगते, काय सांगत नाही, आणि तुम्ही प्रत्यक्षात काय करू शकता — हेच ते सांगतात.
                </p>
              </div>
            </div>

            <div className={styles.uspGrid}>
              <article className={styles.uspCard}>
                <div className={styles.uspIcon}>
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 38L14 28L22 32L34 18" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M28 18H34V24" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                    <rect x="4" y="4" width="40" height="40" rx="2" stroke="white" strokeWidth="2"/>
                  </svg>
                </div>
                <h4 className={styles.uspTitle}>35+ वर्षांचा अनुभव</h4>
                <p className={styles.uspDescription}>
                  Full-time practice, सुरुवातीपासून आजपर्यंत
                </p>
              </article>

              <article className={styles.uspCard}>
                <div className={styles.uspIcon}>
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 4L4 14L24 24L44 14L24 4Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 34L24 44L44 34" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 24L24 34L44 24" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className={styles.uspTitle}>1,50,000+ पत्रिका</h4>
                <p className={styles.uspDescription}>
                  या काळात अभ्यासलेल्या
                </p>
              </article>

              <article className={styles.uspCard}>
                <div className={styles.uspIcon}>
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 4C24 4 36 8 36 16C36 28 24 36 24 44C24 36 12 28 12 16C12 8 24 4 24 4Z" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M16 22L22 28L32 18" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
                <h4 className={styles.uspTitle}>मराठी, हिंदी, English</h4>
                <p className={styles.uspDescription}>
                  तुम्ही ज्या भाषेत विचार करता त्यातच consultation
                </p>
              </article>

              <article className={styles.uspCard}>
                <div className={styles.uspIcon}>
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M24 4V16" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
                    <path d="M24 16C28.4183 16 32 19.5817 32 24C32 28.4183 28.4183 32 24 32C19.5817 32 16 28.4183 16 24C16 19.5817 19.5817 16 24 16Z" stroke="white" strokeWidth="2.5"/>
                    <circle cx="24" cy="24" r="20" stroke="white" strokeWidth="2.5"/>
                  </svg>
                </div>
                <h4 className={styles.uspTitle}>Session स्वतः घेतात</h4>
                <p className={styles.uspDescription}>
                  कधीही दुसऱ्याकडे delegate केलं जात नाही
                </p>
              </article>
            </div>
          </div>
        </section>

        {/* Banner #4: Area-wise Numbers */}
        <ScrollingBanner
          content={[
            '35+ वर्षांचा full-time practice',
            '1,50,000+ पत्रिका अभ्यासलेल्या',
            'प्रत्येक session स्वतः Dr. Kelkar घेतात',
            'मराठी, हिंदी आणि English मध्ये consultation'
          ]}
          speed={28}
          backgroundColor="#B21F25"
          textColor="#FFFFFF"
        />

        {/* Offer Stack Section */}
        <section className={styles.whatYouGetSection} data-section="whatyouget">
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionHeadline}>
              Dr. Kelkar Clarity Session — ₹2,550 मध्ये सगळं काय मिळतं
            </h2>

            <div className={styles.priceComparison}>
              <div className={styles.priceComparisonItem}>
                <div className={styles.priceLabel}>काय मिळतं:</div>
                <ul className={styles.priceList}>
                  <li>
                    <span className={styles.priceAmount}>₹1,500</span>
                    <span className={styles.priceDesc}>सविस्तर Kundali Report — session आधी तयार केलेली</span>
                  </li>
                  <li>
                    <span className={styles.priceAmount}>₹3,000</span>
                    <span className={styles.priceDesc}>1 तासाचा live consultation, प्रत्यक्ष Dr. Kelkar सोबत</span>
                  </li>
                  <li>
                    <span className={styles.priceAmount}>₹500</span>
                    <span className={styles.priceDesc}>संपूर्ण Session Recording</span>
                  </li>
                  <li>
                    <span className={styles.priceAmount}>₹1,000</span>
                    <span className={styles.priceDesc}>Remedy Action Report — लिखित, priority ठरवलेली</span>
                  </li>
                </ul>
                <div className={styles.priceLabel}>एकूण मूल्य: ₹6,000</div>
              </div>

              <div className={`${styles.priceComparisonItem} ${styles.grahboliPrice}`}>
                <div className={styles.priceLabelSpecial}>आज तुम्ही भरता:</div>
                <div className={styles.specialPrice}>₹2,550</div>
                <ul className={styles.benefitsList}>
                  <li>+ Kundali Report</li>
                  <li>+ 1 तास consultation</li>
                  <li>+ Session Recording</li>
                  <li>+ Remedy Action Report</li>
                </ul>
              </div>
            </div>

            <p className={styles.microCopy}>
              ही introductory किंमत फक्त पहिल्यांदा consultation घेणाऱ्यांसाठी आहे.
            </p>

            <button className={styles.primaryCTA} onClick={handleCTAClick}>
              माझं Session Book करा — ₹2,550
            </button>

            <p className={styles.microCopy}>
              Secure payment Razorpay द्वारे · Slot 24 तासांत WhatsApp वर confirm होतो
            </p>
          </div>
        </section>

        {/* How It Works Section */}
        <section className={styles.faqSection} data-section="howitworks">
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionHeadline}>
              Payment पासून Clarity पर्यंत — 3 steps मध्ये
            </h2>

            <div className={styles.stepsRow}>
              <div className={`${styles.comparisonCard} ${styles.stepCard}`}>
                <span className={styles.stepNumber}>1</span>
                <h3 className={styles.comparisonTitle}>Book करा, माहिती द्या</h3>
                <p className={styles.priceDesc}>₹2,550 भरा. पत्रिका तयार ठेवा — जन्म तारीख, नेमकी वेळ आणि ठिकाण जवळ असू द्या.</p>
              </div>

              <div className={`${styles.comparisonCard} ${styles.stepCard}`}>
                <span className={styles.stepNumber}>2</span>
                <h3 className={styles.comparisonTitle}>पत्रिका तयार होते</h3>
                <p className={styles.priceDesc}>Call च्या आधी Dr. Kelkar स्वतः तुमची पत्रिका अभ्यासून सविस्तर Kundali Report तयार करतात.</p>
              </div>

              <div className={`${styles.comparisonCard} ${styles.stepCard}`}>
                <span className={styles.stepNumber}>3</span>
                <h3 className={styles.comparisonTitle}>तुमचं 1 तासाचं session</h3>
                <p className={styles.priceDesc}>तुम्ही थेट त्यांच्याशी बोलता. नंतर तुम्हाला recording आणि Remedy Action Report मिळतो.</p>
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Section - Redesigned */}
        <section className={styles.testimonialsSection} data-section="testimonials">
          <div className={styles.sectionContent}>
            <h2 className={`${styles.sectionHeadline} ${visibleSections.has('testimonials') ? styles.visible : ''} ${styles.fadeInUp}`}>
              Session नंतर लोक काय म्हणतात
            </h2>

            <p className={styles.testimonialSubheading}>
              35+ वर्षांच्या practice मध्ये 1,50,000+ कुटुंबांनी Dr. Kelkar कडून मार्गदर्शन घेतले आहे
            </p>

            {/* Grid view */}
            <div className={`${styles.testimonialsGrid} ${visibleSections.has('testimonials') ? styles.visible : ''} ${styles.staggerChildren}`}>
              {TESTIMONIALS.slice(0, showAllTestimonials ? TESTIMONIALS.length : 4).map((testimonial, index) => (
                <article key={index} className={styles.testimonialCardNew}>
                  <span className={styles.quoteIconNew} aria-hidden="true">&ldquo;</span>

                  <blockquote className={styles.testimonialQuoteNew}>
                    {testimonial.quote}
                  </blockquote>

                  <div className={styles.testimonialFooter}>
                    <div className={styles.testimonialAvatar}>
                      {testimonial.name.charAt(0)}
                    </div>
                    <div className={styles.testimonialInfo}>
                      <cite className={styles.testimonialNameNew}>{testimonial.name}</cite>
                      <p className={styles.testimonialRoleNew}>{testimonial.role}</p>
                    </div>
                  </div>
                </article>
              ))}
            </div>

            {/* Show more button for remaining testimonials */}
            {TESTIMONIALS.length > 4 && (
              <button
                className={styles.showMoreTestimonials}
                onClick={() => setShowAllTestimonials(!showAllTestimonials)}
              >
                {showAllTestimonials
                  ? "Show Less"
                  : `View All ${TESTIMONIALS.length} Testimonials`}
              </button>
            )}
          </div>
        </section>

        {/* Trust Section */}
        <section className={styles.trustSection}>
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionHeadline}>
              10 मिनिटांच्या reading पेक्षा हे session वेगळं का आहे
            </h2>

            <div className={styles.comparisonGrid}>
              <div className={`${styles.comparisonCard} ${styles.othersCard}`}>
                <h3 className={styles.comparisonTitle}>इतर काय देतात</h3>
                <ul className={styles.comparisonList}>
                  <li><Icons.XCircle /> रांगेत एक चेहरा, घाईतलं reading</li>
                  <li><Icons.XCircle /> Call वरच data entry, आधीची तयारी नाही</li>
                  <li><Icons.XCircle /> फक्त तोंडी — लिखित काहीच नाही</li>
                  <li><Icons.XCircle /> ऐकलेलं विसरलं की संपलं</li>
                  <li><Icons.XCircle /> Remedies ची यादी, priority नाही</li>
                </ul>
              </div>

              <div className={`${styles.comparisonCard} ${styles.grahboliCard}`}>
                <h3 className={styles.comparisonTitle}>आम्ही काय देतो</h3>
                <ul className={styles.comparisonList}>
                  <li><Icons.CheckCircle /> पूर्ण तास, एक व्यक्ती, एक पत्रिका</li>
                  <li><Icons.CheckCircle /> Call आधीच पत्रिका अभ्यासलेली</li>
                  <li><Icons.CheckCircle /> Kundali report + Remedy plan लिखित</li>
                  <li><Icons.CheckCircle /> Recording — पुन्हा ऐकता येते</li>
                  <li><Icons.CheckCircle /> Priority ठरवलेले उपाय, कालावधीसह</li>
                </ul>
              </div>
            </div>

            <div ref={socialProofRef} className={styles.socialProofBanner}>
              <div className={styles.proofStat}>
                <div className={styles.proofNumber}>{trustClientCount.toLocaleString()}+</div>
                <div className={styles.proofLabel}>satisfied clients</div>
              </div>
              <div className={styles.proofStat}>
                <div className={styles.proofNumber}>{trustQuestionCount.toLocaleString()}+</div>
                <div className={styles.proofLabel}>पत्रिका अभ्यासलेल्या</div>
              </div>
              <div className={styles.proofStat}>
                <div className={styles.proofNumber}>{trustYearsCount}+ Years</div>
                <div className={styles.proofLabel}>Experience</div>
              </div>
            </div>
          </div>
        </section>

        {/* Banner #3: No Hidden Costs */}
        <ScrollingBanner
          content={[
            'कोणतेही hidden charges नाहीत',
            'कोणताही upselling नाही',
            'Razorpay द्वारे secure payment',
            'पारदर्शक pricing',
            '100% refund जर delivery delay झाली'
          ]}
          speed={22}
          backgroundColor="#B21F25"
          textColor="#FFFFFF"
        />

        {/* Guarantee Section */}
        <section className={styles.priceJustificationSection} data-section="guarantee">
          <div className={styles.sectionContent}>
            <h2 className={styles.sectionHeadline}>
              वेळेत delivery, नाहीतर पैसे परत
            </h2>

            <div className={`${styles.comparisonCard} ${styles.stepCard}`}>
              <span className={styles.checkmark}><Icons.Shield /></span>
              <h3 className={styles.comparisonTitle}>100% Refund on Delayed Delivery</h3>
              <p className={styles.priceDesc}>
                तुमचा सविस्तर Kundali Report आणि Remedy Action Report ठरलेल्या वेळेत देण्याचं आश्वासन आहे. यापैकी कोणतंही delay झालं, तर तुम्हाला 100% refund मिळेल — कोणतेही प्रश्न न विचारता. Delivery चा risk आमचा आहे, तुमचा नाही.
              </p>
            </div>
          </div>
        </section>

        {/* Final CTA Section */}
        <section className={styles.finalCTASection} data-section="finalcta">
          <div className={styles.sectionContent}>
            <p className={styles.finalPush}>
              तुमची पत्रिका आधीच लिहिलेली आहे. ती नीट वाचून घ्या.
            </p>

            <p className={styles.processSteps}>
              Dr. Kelkar यांच्यासोबत 1 तास. सविस्तर report. तुमची recording. अमलात आणता येईल असा remedy plan.
            </p>

            <div className={styles.bigPrice}>₹2,550 फक्त</div>
            <p className={styles.microCopy}>₹6,000 किंमतीचं consultation — आज ₹2,550 मध्ये</p>

            <button className={styles.finalCTAButton} onClick={handleCTAClick}>
              माझं Session Book करा — ₹2,550
            </button>

            <div className={styles.trustElements}>
               दर आठवड्याला मर्यादित slots | 100% refund जर reports delay झाल्या
            </div>

            <p className={styles.socialProofLine}>
              "35+ वर्षं. {finalProofCount.toLocaleString()}+ पत्रिका अभ्यासलेल्या. आता तुमची बारी."
            </p>
          </div>
        </section>

        {/* FAQs Section */}
        <section className={styles.priceJustificationSection} data-section="faqs">
          <div className={styles.sectionContent} style={{ marginBottom: '2rem' }}>
            <h2 className={styles.sectionHeadline}>
              वारंवार विचारले जाणारे प्रश्न
            </h2>

            <div className={styles.faqAccordion}>
              {FAQS.map((faq, index) => (
                <div key={index} className={styles.faqItem}>
                  <button
                    className={styles.faqQuestion}
                    onClick={() => setExpandedFAQ(expandedFAQ === index ? null : index)}
                    aria-expanded={expandedFAQ === index}
                  >
                    <span>{expandedFAQ === index ? '▲' : '▼'}</span>
                    {faq.question}
                  </button>

                  {expandedFAQ === index && (
                    <div className={styles.faqAnswer}>
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Sticky CTA Bar */}
        {showStickyCTA && (
          <div className={styles.stickyCTABar}>
            <button onClick={handleCTAClick}>
              Book Now — ₹2,550
            </button>
          </div>
        )}
      </div>

    </>
  );
}
